import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { AggrDeviceFieldAggrResponse } from '@/api/routes/stat/types';

import { fetchStaticMileageAggrByDay } from './actionCreators';

interface InitialState {
  mileageByDay: number[],
  timeBegin: number | null,
  timeEnd: number | null,
  isLoading: boolean,
  error: string,
}

const initialState: InitialState = {
  mileageByDay: [],
  timeBegin: null,
  timeEnd: null,
  isLoading: false,
  error: '',
};

export const staticAggrMileageByDaySlice = createSlice({
  name: 'staticAggrMileageByDay',
  initialState,
  reducers: {
    selectTime: (state, action: PayloadAction<{
      timeBegin: number,
      timeEnd: number,
    }>) => {
      state.timeBegin = action.payload.timeBegin;
      state.timeEnd = action.payload.timeEnd;
    },
  },
  extraReducers: {
    [fetchStaticMileageAggrByDay.fulfilled.type]: (state, action: PayloadAction<AggrDeviceFieldAggrResponse>) => {
      state.isLoading = false;
      state.error = '';
      state.mileageByDay = action.payload;
    },
    [fetchStaticMileageAggrByDay.pending.type]: (state) => {
      state.isLoading = true;
    },
    [fetchStaticMileageAggrByDay.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const { selectTime } = staticAggrMileageByDaySlice.actions;
export default staticAggrMileageByDaySlice.reducer;
